<template>
  <div class="platform-updates-tab">
    <InfoModal />
    <DxCheckBox v-model="showBox" text="Show block" />
    <DxValidationGroup ref="validationGroup">
      <div
        v-for="field in stringFields"
        :key="field.key"
        style="margin-top:18px"
      >
        <DxTextBox
          v-if="field.isEditor == false"
          v-model="getFieldModel(field.key).value"
          :label="field.label"
          class="custom-input"
        >
          <DxValidator :validation-rules="[requiredFieldRule]" />
        </DxTextBox>

        <div class="introduction-input" v-else>
          <span class="input-title q-mt-md">{{ field.label }}</span>

          <ckeditor
            :editor="editorRefUpdates.help.editor"
            v-model="getFieldModel(field.key).value"
            :config="editorRefUpdates.help.editorConfig"
          ></ckeditor>
        </div>
      </div>
    </DxValidationGroup>

    <h2 class="release-notes-heading">Release notes for authenticated users</h2>
    <div
      v-for="field in releaseNotesFields"
      :key="field.key"
      style="margin-top:18px"
    >
      <div class="introduction-input">
        <span class="input-title q-mt-md">{{ field.label }}</span>

        <ckeditor
          :editor="editorRefUpdates.help.editor"
          v-model="getFieldModel(field.key).value"
          :config="editorRefUpdates.help.editorConfig"
          @ready="editor => setEditorLabel(editor, field.label)"
        ></ckeditor>
      </div>
    </div>

    <DxButton
      text="Save"
      @click="updateSettings"
      class="orange-btn custom-btn"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import store from "../../store/index";
import globalSettingsService from "../../services/global.settings.service";

import InfoModal from "../global-components/InfoModal.vue";

import DxValidationGroup from "devextreme-vue/validation-group";
import DxTextBox from "devextreme-vue/text-box";
import DxValidator from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxCheckBox from "devextreme-vue/check-box";

import help from "../../helpers/editor";

const editorRefUpdates = help;

const requiredFieldRule = {
  type: "required",
  message: "Field is required"
};

onMounted(async () => {
  globalSettingsService.getGlobalSettings();
});

const showBox = computed({
  get: () => store.state.globalSettings.settings.showBoxInContent,
  set: val => store.commit("globalSettings/updateShowBox", val)
});

const stringFields = [
  { key: "boxTitleNL", label: "Box title NL", isEditor: false },
  { key: "boxContentNL", label: "Box content NL", isEditor: true },
  {
    key: "releaseNotesButtonLabelNL",
    label: "Release notes label NL",
    isEditor: false
  },
  {
    key: "platformUpdatesButtonLabelNL",
    label: "Platform updates label NL, isEditor: false ",
    isEditor: false
  },
  {
    key: "scheduledMaintenanceButtonLabelNL",
    label: "Scheduled maintenance label NL",
    isEditor: false
  },
  {
    key: "releaseNotesButtonLinkNL",
    label: "Release notes link NL",
    isEditor: false
  },
  {
    key: "platformUpdatesButtonLinkNL",
    label: "Platform updates link NL",
    isEditor: false
  },
  {
    key: "scheduledMaintenanceButtonLinkNL",
    label: "Scheduled maintenance link NL",
    isEditor: false
  },

  { key: "boxTitleDE", label: "Box title DE", isEditor: false },
  { key: "boxContentDE", label: "Box content DE", isEditor: true },
  {
    key: "releaseNotesButtonLabelDE",
    label: "Release notes label DE",
    isEditor: false
  },
  {
    key: "platformUpdatesButtonLabelDE",
    label: "Platform updates label DE",
    isEditor: false
  },
  {
    key: "scheduledMaintenanceButtonLabelDE",
    label: "Scheduled maintenance label DE",
    isEditor: false
  },
  {
    key: "releaseNotesButtonLinkDE",
    label: "Release notes link DE",
    isEditor: false
  },
  {
    key: "platformUpdatesButtonLinkDE",
    label: "Platform updates link DE",
    isEditor: false
  },
  {
    key: "scheduledMaintenanceButtonLinkDE",
    label: "Scheduled maintenance link DE",
    isEditor: false
  }
];

const releaseNotesFields = [
  { key: "releaseNotesContentNL", label: "Content release notes NL" },
  { key: "releaseNotesContentDE", label: "Content release notes DE" },
  { key: "releaseNotesSasNL", label: "SAS release notes NL" },
  { key: "releaseNotesSasDE", label: "SAS release notes DE" }
];

// CKEditor names every editable "Rich Text Editor, main"; give screen readers the field label instead
const setEditorLabel = (editor, label) => {
  editor.editing.view.change(writer => {
    writer.setAttribute(
      "aria-label",
      label,
      editor.editing.view.document.getRoot()
    );
  });
};

const getFieldModel = key =>
  computed({
    // new columns are NULL until saved; CKEditor throws on data.set(null)
    get: () => store.state.globalSettings.settings[key] ?? "",
    set: value => {
      store.commit("globalSettings/updateSetting", { key, value });
    }
  });

const settingsStore = computed({
  get: () => store.state.globalSettings.settings
});

const updateSettings = async () => {
  globalSettingsService.updateGlobalSettings(settingsStore.value);
};
</script>
<style lang="scss"></style>
